import { UserAction, UserActionTypes, UserState } from '../../types/user';

const initialState: UserState = {
  users: [],
  loading: true,
  btnLoading: false,
};

export const userReducer = (
  state = initialState,
  action: UserAction
): UserState => {
  switch (action.type) {
    case UserActionTypes.GET_ALL_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
      };
    case UserActionTypes.USERS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case UserActionTypes.BTN_LOADING:
      return {
        ...state,
        btnLoading: action.payload,
      };
    case UserActionTypes.CLEAR_USER:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
